<template>
  <div class="sampleDialog">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Dialog Options</span>
        <div class="right-button">
          <el-button class="" @click="showDialog()">Dialog</el-button>
        </div>
      </div>
      <div class="options">
        <div>
          <span>넓이:</span>
          <el-input v-model="width"></el-input>
        </div>
        <div>
          <span>Top:</span>
          <el-input v-model="top"></el-input>
        </div>
        <div>
          <span>위치:</span>
          <el-select v-model="customClass">
            <el-option
              v-for="item in styles"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>모달:</span>
          <el-checkbox v-model="modal"></el-checkbox>
        </div>
      </div>
    </el-card>    
    <el-dialog
      title="Dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :width="width"
      :modal="modal"
      :top="top"      
      :visible.sync="dialogVisible"
      :custom-class="customClass"
    >
    </el-dialog>
  </div>
</template>

<script>
export default {  
  name: 'sampleDialog',
  data() {
    return {
      dialogVisible: false,
      width: '900px',
      modal: true,
      top: '0px',
      customClass: '',
      styles: [
        { value: '', label: '없음' },
        { value: 'top-left', label: '상단 좌측' },
        { value: 'top-right', label: '상단 우측' },
        { value: 'bottom-left', label: '하단 좌측' },
        { value: 'bottom-right', label: '하단 우측' }
      ]
    };
  },
  methods: {
    showDialog () {
      this.dialogVisible = true;
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box-card { width: 400px; }
.right-button { float: right; right: 10px; top: 10px; vertical-align: middle; }
.options {
  & div { 
    height: 40px; line-height: 40px;
    margin-bottom: 10px;
    & span { display: inline-block; width: 60px; }
    & *:nth-child(2) { display: inline-block; width: 80%; }
  }
}
</style>
<style>
.top-left { position: absolute; top: 0; left: 0; }
.top-right { position: absolute; top: 0; right: 0; }
.bottom-left { position: absolute; bottom: 0; left: 0; }
.bottom-right { position: absolute; bottom: 0; right: 0; }
</style>
